import React from "react";
import clsx from "clsx";
import { MAX_ROW_ID, ZINDEX } from "./constants";

/**
 * AttributesCell Component
 * Displays record attributes with tooltip and expandable functionality
 * @param {Object} row - The row data object
 */
const AttributesCell = ({ row }) => {
  const showValue = false;
  const isPinned = row.getIsPinned();
  const columnIsPinned = row.getContext().column.isPinned();
  const showTooltip = !showValue && !isPinned && !columnIsPinned;

  return (
    <div className="relative ">
      {!showValue && (
        <span
          className={clsx(
            `w-full text-left inline-block cursor-pointer text-primary-400`,
            showTooltip && "has-tooltip"
          )}
        >
          <span className="whitespace-nowrap">
            {row.original.recordAttributes &&
              `Expand ${row.original.recordAttributes.length} Attributes ⤵`}
          </span>
          {showTooltip && (
            <span
              className={clsx(
                `tooltip rounded shadow-xl px-5 py-2`,
                row.id < MAX_ROW_ID ? "top-full" : "bottom-full mb-2",
                `left-0 -translate-x-4 bg-white opacity-88 text-[#777f9e] z-[${
                  ZINDEX - row.id
                }]`
              )}
            >
              {row.original.recordAttributes &&
                row.original.recordAttributes.map((attr, index) => (
                  <div
                    key={index}
                    className="flex flex-row justify-between gap-10 mt-[3px] mb-[3px]"
                  >
                    <span className="py-[2px] whitespace-nowrap text-sm font-semibold">
                      {attr.name}
                    </span>
                    <span className="py-[2px] px-[8px] whitespace-nowrap ltr:text-right rtl:text-left text-md">
                      {attr.value}
                    </span>
                  </div>
                ))}
            </span>
          )}
        </span>
      )}
      {showValue && (
        <div className="relative z-10 ltr:left-[10px] rtl:right-[10px] top-[20px]">
          <span className="w-full text-left block cursor-pointer mb-1 text-red-400">
            {"Collapse Attributes"} {"⤴"}
          </span>
          <div className="flex flex-col min-w-[264px] transition-all bg-primary-dark dark:text-white text-[#777f9e] text-14 rounded-lg px-[2px] py-[8px] mb-3 opacity-100">
            {row.original.recordAttributes &&
              row.original.recordAttributes.map((attr, index) => (
                <div
                  key={index}
                  className="flex flex-row justify-between gap-2 mb-[2px]"
                >
                  <span className="py-[2px] whitespace-nowrap text-xs font-semibold">
                    {attr.name}
                  </span>
                  <span className="py-[2px] px-[8px] whitespace-nowrap ltr:text-right rtl:text-left text-sm">
                    {attr.value}
                  </span>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AttributesCell;
